import { useQuery } from '@tanstack/react-query';
import { aiStudioService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from '../../../constant/queryKey';
import { usePostGoodsActionMode } from '../context/PostGoodsActionContext';

export const useAiStudioBanner = () => {
  const goodsSno = useGoodsSno();
  const mode = usePostGoodsActionMode();

  return useQuery({
    queryKey: queryKey.aiStudioBanner(goodsSno, mode),
    queryFn: () =>
      aiStudioService.getRepresentativeImageRedirectPath({
        goods_sno: goodsSno,
        entry_point:
          mode === 'like'
            ? 'GOODS_DETAIL_LIKE_BOTTOM_SHEET'
            : 'GOODS_DETAIL_CART_BOTTOM_SHEET',
        product_type: 'FITTING_ROOM_OUTFIT_TRY_ON',
      }),
  });
};
